<template>
  <div class="smart-cr-data" id="smart-cr-data">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/ApprovalIndex"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div class="content_title">
      <div class="d-list">
        <div class="title" @click="toggle('daShow')">Basic Information</div>
        <transition name="fade">
          <div class="table" v-show="daShow">
            <div class="content">
              <div class="row">
                <p>
                  <span class="txt"> CR Type: </span>
                  <span class="val">
                    <el-select
                      v-model="CRType"
                      placeholder="Please select"
                      class="val-input"
                    >
                      <el-option
                        v-for="item in CRTypeOPtion"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </span>
                </p>
                <p>
                  <span class="txt"> Submission Date: </span>
                  <span class="val">
                    <el-date-picker
                      v-model="SubmissionDate"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      class="val-input"
                      disabled="disabled"
                    >
                    </el-date-picker>
                  </span>
                </p>
                <p>
                  <span class="txt"> Legal Entity: </span>
                  <span class="val">
                    <el-select
                      v-model="LegalEntity"
                      placeholder="Please select"
                      class="val-input"
                    >
                      <el-option
                        v-for="item in LegalEntityOPtion"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </span>
                </p>
              </div>
              <div class="row">
                <p>
                  <span class="txt"> First Budget Owner Department:</span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="FristDepartment"
                      placeholder="Please input"
                      type="text"
                    ></el-input
                  ></span>
                </p>
                <p>
                  <span class="txt"> Second Budget Owner Department: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="SecondDepartment"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
                <p>
                  <span class="txt"> Third Budget Owner Department: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="ThirdDepartment"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
              </div>
              <div class="row">
                <p>
                  <span class="txt"> Requestor Name: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="RequestorName"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
                <p>
                  <span class="txt"> Requestor Email: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="RequestorEmail"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
                <p>
                  <span class="txt"> Requesting Department: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="RequestingDepartment"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
              </div>
              <div class="row">
                <p>
                  <span class="txt"> Functional Head: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="FunctionalHead"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
                <p>
                  <span class="txt"> Department Coordinator: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="DepartmentCoordinator"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
                <p style="display:none;">
                  <span class="txt"> Project Item: </span>
                  <span class="val">
                    <el-select
                      v-model="ProjectItem"
                      placeholder="Please select"
                      class="val-input"
                    >
                      <el-option
                        v-for="item in ProjectItemOption"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </span>
                </p>
              </div>
              <div class="row" style="display: none">
                <p>
                  <span class="txt"> Delivery Date (Goods): </span>
                  <span class="val">
                    <el-date-picker
                      v-model="DeliveryDate"
                      :picker-options="expireTimeOption"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      class="val-input"
                    >
                    </el-date-picker>
                  </span>
                </p>
                <p>
                  <span class="txt">Delivery Duration (Service): </span>
                  <span class="val">
                    <el-date-picker
                      v-model="DeliveryDurationFrom"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      class="val-input"
                      disabled="disabled"
                    >
                    </el-date-picker>
                    <el-date-picker
                      v-model="DeliveryDurationTo"
                      type="date"
                      placeholder="选择日期"
                      class="val-input"
                      style="margin-left: 10px"
                      value-format="yyyy-MM-dd"
                      disabled="disabled"
                    >
                    </el-date-picker>
                  </span>
                </p>
              </div>
              <div class="row">
                <p class="d-flex-2">
                  <span class="txt"> Project Name: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="ProjectName"
                      placeholder="Please input"
                      type="text"
                      disabled="disabled"
                    ></el-input>
                    <el-button
                      type="primary"
                      plain
                      style="margin-left: 10px"
                      @click="dialogProjectVisible = true"
                      >Detail</el-button
                    >
                  </span>
                </p>
              </div>
              <div class="row row-textarea">
                <p>
                  <span class="txt"> Statement of Business Needs: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="StatementBusinessNeeds"
                      placeholder="Please input"
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      :resize="'none'"
                      disabled="disabled"
                    ></el-input>
                    <el-button
                      type="primary"
                      plain
                      style="margin-left: 10px"
                      @click="dialogStatementVisible = true"
                      >Detail</el-button
                    >
                  </span>
                </p>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="d-list" style="display:none;">
        <div class="title" @click="toggle('dbShow')">
          Vendor Pitching Waiver Application
        </div>
        <transition name="fade">
          <div class="table" v-show="dbShow">
            <div>
              <div class="reason">
                Reason for Vendor Pitching Waiver( Please specify the reasons
                and attach supporting files where necessary):
              </div>
              <div class="reason-comment">
                <el-input
                  class="val-input"
                  v-model="reasonComment"
                  placeholder="Please input"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  :resize="'none'"
                ></el-input>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="d-list">
        <div class="title" @click="toggle('dcShow')">Project Information</div>
        <transition name="fade">
          <div class="table" v-show="dcShow">
            <div class="content">
              <div class="row">
                <p>
                  <span class="txt"> NTP Buyer(Capex):</span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="NTPBuyer_Capex"
                      placeholder="Please input"
                      type="text"
                    ></el-input
                  ></span>
                </p>
                <p>
                  <span class="txt"> NTP Buyer(Opex):</span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="NTPBuyer_Opex"
                      placeholder="Please input"
                      type="text"
                    ></el-input
                  ></span>
                </p>
                <p>
                  <span class="txt"> NTP Buyer(Digital):</span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="NTPBuyer_Digital"
                      placeholder="Please input"
                      type="text"
                    ></el-input
                  ></span>
                </p>
              </div>
              <div class="row">
                <p>
                  <span class="txt"> Vendor Name CN: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="VendorNameCN"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
                <p>
                  <span class="txt"> Vendor Name EN: </span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="VendorNameEN"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </span>
                </p>
                <p>
                  <span class="txt"> Vendor Email:</span>
                  <span class="val">
                    <el-input
                      class="val-input"
                      v-model="VendorEmail"
                      placeholder="Please input"
                      type="text"
                    ></el-input
                  ></span>
                </p>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="d-list">
        <div class="title" @click="toggle('ddShow')">Account Information</div>
        <transition name="fade">
          <div class="table" v-show="ddShow">
            <div class="columns">
              <div class="column">Item</div>
              <div class="column">MWB Project? (for Marketing)</div>
              <div class="column">Project Recommendation#</div>
              <div class="column">Cost Center</div>
              <div class="column">Internal Order</div>
              <div class="column">Asset#</div>
              <div class="column">A/C</div>
              <div class="column">Budget Owner Department</div>
              <div class="column">Budget Year</div>
              <div class="column">Amount (excl. VAT)</div>
              <div class="column">Action</div>
            </div>
            <div class="tbody">
              <template v-for="(item, index) in columns">
                <div :key="index" class="item">
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.item"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.mwbProject"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.projectRecommendation"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.costCenter"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <!-- <el-input
                      class="val-input"
                      v-model="item.internalOrder"
                      placeholder="Please input"
                      type="text"
                    ></el-input> -->                    
                    <el-button class="val-input" type="primary" plain @click="dialogInternalOrderVisible = true">Detail</el-button>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.asset"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.ac"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.budgetOwnerDepartment"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.budgetYear"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-input
                      class="val-input"
                      v-model="item.amountexclVAT"
                      placeholder="Please input"
                      type="text"
                    ></el-input>
                  </div>
                  <div class="t-input">
                    <el-button class="val-input addcolumn" @click="addColumn()">
                      +
                    </el-button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </transition>
      </div>
      <div class="d-list">
        <div class="title" @click="toggle('deShow')">
          Functional Approval Hierarchy
        </div>
        <!-- style="width: 100%; display: flex; align-items: center" -->
        <transition name="fade">
          <div class="content" style="width: 100%">
            <div
              class="table"
              v-show="deShow"
              style="width: 100%; display: flex"
            >
              <div
                class="table-label"
                style="margin-right: 6px; padding-top: 20px"
              >
                Approval Process:
              </div>
              <div style="flex: 1">
                <div class="columns">
                  <div class="column" style="color: black">Approval Rules</div>
                  <div class="column" style="color: black; flex: 2">Amount</div>
                  <div
                    class="column"
                    style="
                      color: black;
                      width: 80px;
                      flex: none;
                      diplay: flex;
                      justify-content: center;
                    "
                  >
                    <el-button
                      class="val-input addcolumn"
                      @click="addApprovalRules()"
                    >
                      +
                    </el-button>
                  </div>
                </div>
                <div class="tbody">
                  
                    <template v-for="(items, index) in approvalData">
                      <div :key="index" class="item">
                        <div class="t-input">
                          <el-select
                            v-model="items.approvalRules"
                            placeholder="Please select"
                            class="val-input"
                          >
                            <el-option
                              v-for="items in hierarchyData"
                              :key="items.id"
                              :label="items.approvalRule"
                              :value="items.approvalRule"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="t-input" style="flex: 2">
                          <el-input
                            class="val-input numrule"
                            v-model="items.amountStart"
                            placeholder="Please input"
                            precision="2"
                            type="number"
                            :readonly="true"
                          ></el-input>
                          -
                            <el-input
                              class="val-input numrule"
                              v-model="items.amountEnd"
                              placeholder="Please input"
                              precision="2"
                              type="number"
                              @change="changeApprovalRules(index)"
                            ></el-input>                         
                        </div>
                        <div  class="t-input"
                          style="width: 80px;
                            flex: none;
                            diplay: flex;
                            justify-content: center;">
                          <el-button @click="removeApprovalRules(index)">
                            -
                          </el-button>
                        </div>
                      </div>
                    </template>
                 
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="btn">
        <el-button class="button-search" @click="save">Save</el-button>
      </div>

      <el-dialog
        title="拼接规则：固定前缀+年份+月份+批次+分类+for+店铺数量+bud类型+固定后缀"
        :visible.sync="dialogProjectVisible"
        style="float: left"
        :close-on-click-modal="false"
        width="90%" center
        @close="onClose"
      >
        <div slot="title" style="float: left">
          <span
            >拼接规则：固定前缀+年份+月份+批次+分类+for+店铺数量+bud类型+固定后缀</span
          >
        </div>
        <el-table :data="projectData" border style="font-size: 13px" fit>
          <!-- <el-table-column label="" width="55">
            <template slot-scope="scope">
              <template v-if="scope.row.isEdit">
                <i
                  class="el-icon-document"
                  @click="saveRowEvent(scope.row)"
                ></i>
                <i
                  class="fa el-icon-refresh-left"
                  @click="cancelRowEvent(scope.row)"
                ></i>
              </template>
              <template v-else>
                <i
                  class="el-icon-edit-outline"
                  @click="editRowEvent(scope.row)"
                ></i>
              </template>
            </template>
          </el-table-column> -->

          <el-table-column
            property="category"
            label="类别"
            width="60"
          ></el-table-column>
          <el-table-column property="prefix" label="固定前缀" width="200">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.prefix"
                size="mini"
                placeholder="Please input"
              />
            </template>
          </el-table-column>
          <el-table-column property="year" label="年份!" width="60">
            <template slot="header">
              <el-tooltip content="固定为当前年份" placement="top">
                <div>年份!</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column property="month" label="月份!" width="55">
            <template slot="header">
              <el-tooltip content="固定为当前月份" placement="top">
                <div>月份!</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column property="batchNo" label="批次!" width="70">
            <template slot="header">
              <el-tooltip content="系统自动生成批次" placement="top">
                <div>批次!</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column property="classify" label="分类!" width="55">
            <template slot="header">
              <el-tooltip
                content="Digtial固定为-0，Capex固定为-1，Opex固定为-2"
                placement="top"
              >
                <div>分类!</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column property="fors" label="for!" width="40">
            <template slot="header">
              <el-tooltip content="固定为for" placement="top">
                <div>for!</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column property="storeNumber" label="店铺数量!" width="80">
            <template slot="header">
              <el-tooltip
                content="系统自动计算该批次的店铺数量"
                placement="top"
              >
                <div>店铺数量!</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column property="bud" label="bud类型!" width="100">
            <template slot="header">
              <el-tooltip
                content="固定为New Stores或Upgrade Stores"
                placement="top"
              >
                <div>bud类型!</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column property="suffix" label="固定后缀" min-width="220">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.suffix"
                size="mini"
                placeholder="Please input"
              />
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" @click="saveRowEvent()">Save</el-button>
        </span>
      </el-dialog>

      <el-dialog
        width="90%"
        :visible.sync="dialogStatementVisible"
        :close-on-click-modal="false"
        @close="onClose" center
      >
        <el-table
          :data="projectData"
          border
          style="font-size: 13px"
          fit
          tooltip-effect="dark"
          class="tabledetail"
        >
          <!-- <el-table-column label="" width="55">
            <template slot-scope="scope">
              <template v-if="scope.row.isEdit">
                <i
                  class="el-icon-document"
                  @click="saveRowEvent(scope.row)"
                ></i>
                <i
                  class="fa el-icon-refresh-left"
                  @click="cancelRowEvent(scope.row)"
                ></i>
              </template>
              <template v-else>
                <i
                  class="el-icon-edit-outline"
                  @click="editRowEvent(scope.row)"
                ></i>
              </template>
            </template>
          </el-table-column> -->

          <el-table-column
            property="category"
            label="类别"
            width="60"
          ></el-table-column>

          <el-table-column
            property="statement_of_business_needs"
            label="For statement of business needs"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.statement_of_business_needs"
                size="mini"
                placeholder="Please input"
              />
              <!-- {{ scope.row.statement_of_business_needs }} -->
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" @click="saveRowEvent()">Save</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="dialogInternalOrderVisible"
        style="float: left"
        :close-on-click-modal="false"
        width="50%" center
        @close="onClose"
      >
        <el-table :data="internalOrderData" border style="font-size: 13px" fit>
          <el-table-column
            property="channel"
            label="Channel"
            width="100"
          ></el-table-column>
          <el-table-column property="CapexIO" label="Capex IO" width="auto">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.capexIO"
                size="mini"
                placeholder="Please input"
              />
            </template>
          </el-table-column>
        
          <el-table-column property="OpexIO" label="Opex IO" width="auto">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.opexIO"
                size="mini"
                placeholder="Please input"
              />
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" @click="saveInternalOrderRowEvent()">Save</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dynamicValidateForm: [{
        amountEnd:''
      }],
      expireTimeOption: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          const now = new Date();
          const year = now.getFullYear();
          const month = now.getMonth() + 1;
          const start = new Date(year, month - 1, 1);
          const nextyear = month == 12 ? year + 1 : year;
          const nextmonth = month == 12 ? 1 : month + 1;
          const nextday = new Date(nextyear, nextmonth, 0).getDate();
          const next = new Date(nextyear, nextmonth - 1, nextday);
          return date.getTime() > next || date.getTime() < start;
        },
      },
      daShow: true,
      dbShow: true,
      dcShow: true,
      ddShow: true,
      deShow: true,
      id: "",
      APoptions: ["小于10W", "大于10W"],
      CRTypeOPtion: ["Normal", "Store Support"],
      LegalEntityOPtion: [
        "adidas Sports (China) Co.,Ltd.",
        "adidas (China) Ltd.",
        "adidas (Suzhou) Co.,Ltd.(PO genreated in adirace)",
        "adidas Logistics (Tianjin) Co.,Ltd.",
      ],
      ProjectItemOption: [
        "Decoration",
        "Decoration Supplement",
        "Façade",
        "PM service",
        "RFID",
        "VM related",
        "Traffic counter",
        "Trade meeting",
        "Design testing",
        "Others",
      ],
      CRType: "",
      LegalEntity: "",
      FristDepartment: "",
      SecondDepartment: "",
      ThirdDepartment: "",
      SubmissionDate: "",
      RequestorName: "",
      RequestorEmail: "",
      RequestingDepartment: "",
      FunctionalHead: "",
      DepartmentCoordinator: "",
      ProjectName: "",
      ProjectItem: "",
      StatementBusinessNeeds: "",
      DeliveryDate: "",
      DeliveryDurationFrom: "",
      DeliveryDurationTo: "",
      reasonComment: "",
      NTPBuyer_Capex: "",
      NTPBuyer_Opex: "",
      NTPBuyer_Digital: "",
      VendorNameCN: "",
      VendorNameEN: "",
      VendorEmail: "",
      columns: [
        {
          id: 0,
          item: "",
          mwbProject: "",
          projectRecommendation: "",
          costCenter: "",
          internalOrder: "",
          asset: "",
          ac: "",
          budgetOwnerDepartment: "",
          budgetYear: "",
          amountexclVAT: "",
        },
      ],
      ApprovalProcess: "",
      dialogProjectVisible: false,
      dialogStatementVisible: false,
      projectData: [],
      approvalData: [
        {
          id: 0,
          approvalRules: "",
          amountStart: "",
          amountEnd: "",
        },
      ],
      hierarchyData: [],
      dialogInternalOrderVisible:false,
      internalOrderData:[]
    };
  },
  methods: {
    toggle(show) {
      this[show] = !this[show];
    },
    addColumn() {
      debugger;
      var maxid = this.Max(this.columns.map((a) => a.id));
      var oo = {
        id: maxid + 1,
        item: "",
        mwbProject: "",
        projectRecommendation: "",
        costCenter: "",
        internalOrder: "",
        asset: "",
        ac: "",
        budgetOwnerDepartment: "",
        budgetYear: "",
        amountexclVAT: "",
      };
      this.columns.push(oo);
    },
    addApprovalRules() {
      var maxid = this.approvalData.length;
      if (maxid > 1)
        this.approvalData[maxid - 1].amountEnd = (
          Number(this.approvalData[maxid - 1].amountStart) + 99999.99
        ).toFixed(2);
      var Ap = {
        id: maxid + 1,
        approvalRules: this.hierarchyData[0].approvalRule,
        amountStart: (
          parseFloat(this.Max(this.approvalData.map((a) => a.amountEnd))) + 0.01
        ).toFixed(2),
        amountEnd: parseFloat(1000000000).toFixed(2),
      };
      this.approvalData.push(Ap);
    },
    removeApprovalRules(index) {
      if (this.approvalData.length > 1) {
        if (index == this.approvalData.length - 1 && index != 0) {
          if (index - 1 != 0)
            this.approvalData[index - 1].amountEnd = 1000000000.0;
        } else {
          //if(index-1!=0)
          this.approvalData[index + 1].amountStart =
            parseFloat(this.approvalData[index - 1].amountEnd) + 0.01;
        }

        if (index != 0) this.approvalData.splice(index, 1);
      }
    },
    changeApprovalRules(index) {
      if (this.approvalData[index].amountEnd == "") {
        this.$message({
          type: "error",
          message: "金额区间不允许为空，请确保右侧金额完整",
        });
        if (index == 0) {
          this.approvalData[0].amountEnd = Number(100000).toFixed(2);
        } else if (index == this.approvalData.length - 1) {
          this.approvalData[index].amountEnd = Number(1000000000).toFixed(2);
        } else {
          this.approvalData[index].amountEnd = parseFloat(
            this.approvalData[index + 1].amountStart - 0.01
          ).toFixed(2);
          this.approvalData[index + 1].amountStart = (
            parseFloat(this.approvalData[index].amountEnd) + 0.01
          ).toFixed(2);
        }
        return false;
      }

      if (
        parseFloat(this.approvalData[index].amountEnd) <
        parseFloat(this.approvalData[index].amountStart)
      ) {
        this.$message({
          type: "error",
          message: "同一行中右侧的金额需大于左侧的金额",
        });
        if (index == 0) {
          this.approvalData[0].amountEnd = Number(100000).toFixed(2);
        } else if (index == this.approvalData.length - 1) {
          this.approvalData[index].amountEnd = Number(1000000000).toFixed(2);
        } else {
          this.approvalData[index].amountEnd = parseFloat(
            this.approvalData[index + 1].amountStart - 0.01
          ).toFixed(2);
          this.approvalData[index + 1].amountStart = (
            parseFloat(this.approvalData[index].amountEnd) + 0.01
          ).toFixed(2);
        }

        return false;
      }
    },

    Max(arr) {
      if (arr.length > 0) {
        var MaxNumber = arr[0];
        for (var i = 0; i < arr.length; i++) {
          if (MaxNumber < arr[i]) {
            MaxNumber = arr[i];
          }
        }
        return MaxNumber;
      } else {
        return 0;
      }
    },
    isEmpty(str) {
      if (str == "" || str == null || str == undefined) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      if (this.isEmpty(this.CRType)) {
        this.$message({
          type: "error",
          message: "Please choose CR Type",
        });
        return;
      }

      var arr = this.approvalData.map((a) => a.approvalRules);
      var disarr = [...new Set(arr)];
      if (arr.length != disarr.length) {
        this.$message({
          type: "error",
          message: "Approval Rules不能重复",
        });
        return;
      }

      this.$api
        .post(
          "/CR/SaveSmartCRData",
          {
            ID: this.ID,
            CRType: this.CRType,
            SubmissionDate: this.SubmissionDate,
            LegalEntity: this.LegalEntity,
            FirstBudgetOwnerDepartment: this.FristDepartment,
            SecondBudgetOwnerDepartment: this.SecondDepartment,
            ThirdBudgetOwnerDepartment: this.ThirdDepartment,
            RequestorName: this.RequestorName,
            RequestorEmail: this.RequestorEmail,
            RequestingDepartment: this.RequestingDepartment,
            FunctionalHead: this.FunctionalHead,
            DepartmentCoordinator: this.DepartmentCoordinator,
            ProjectName: this.ProjectName,
            ProjectItem: this.ProjectItem,
            StatementofBusinessNeeds: this.StatementBusinessNeeds,
            DeliveryDateGoods: this.DeliveryDate,
            DeliveryDurationStart: this.DeliveryDurationFrom,
            DeliveryDurationEnd: this.DeliveryDurationTo,
            VPWApplication: this.reasonComment,
            NTPBuyerCapex: this.NTPBuyer_Capex,
            NTPBuyerOpex: this.NTPBuyer_Opex,
            NTPBuyerDigital: this.NTPBuyer_Digital,
            VendorNameCN: this.VendorNameCN,
            VendorNameEN: this.VendorNameEN,
            VendorEmail: this.VendorEmail,
            ApprovalProcess: this.ApprovalProcess,
            Infos: JSON.stringify(this.columns),
            ApprovalRules: JSON.stringify(this.approvalData),
          },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: res.data.content,
            });
            this.bind();
            this.bindApprovalHierarchy();
            this.bindApprovalRules();
            this.bindInternalOrder();
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    bind() {
      this.$api
        .get("/CR/SmartCRInfo/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.ID = res.data.content.id;
            this.CRType = res.data.content.crType;
            this.SubmissionDate =
              res.data.content.submissionDate.length > 0
                ? res.data.content.submissionDate.substring(0, 10)
                : "";
            this.LegalEntity = res.data.content.legalEntity;
            this.FristDepartment = res.data.content.firstBudgetOwnerDepartment;
            this.SecondDepartment =
              res.data.content.secondBudgetOwnerDepartment;
            this.ThirdDepartment = res.data.content.thirdBudgetOwnerDepartment;
            this.RequestorName = res.data.content.requestorName;
            this.RequestorEmail = res.data.content.requestorEmail;
            this.RequestingDepartment = res.data.content.requestingDepartment;
            this.FunctionalHead = res.data.content.functionalHead;
            this.DepartmentCoordinator = res.data.content.departmentCoordinator;
            this.ProjectName = res.data.content.projectName;
            this.ProjectItem = res.data.content.projectItem;
            this.StatementBusinessNeeds =
              res.data.content.statementofBusinessNeeds;
            this.DeliveryDate = ""; //res.data.content.deliveryDateGoods;
            this.DeliveryDurationFrom = res.data.content.deliveryDurationStart;
            this.DeliveryDurationTo = res.data.content.deliveryDurationEnd;
            this.reasonComment = res.data.content.vpwApplication;
            this.NTPBuyer_Capex = res.data.content.ntpBuyerCapex;
            this.NTPBuyer_Opex = res.data.content.ntpBuyerOpex;
            this.NTPBuyer_Digital = res.data.content.ntpBuyerDigital;
            this.VendorNameCN = res.data.content.vendorNameCN;
            this.VendorNameEN = res.data.content.vendorNameEN;
            this.VendorEmail = res.data.content.vendorEmail;
            this.ApprovalProcess = res.data.content.approvalProcess;
            this.columns = res.data.content.infos;
            console.log(this.columns);
            this.bindApprovalRules();
            this.bindInternalOrder();
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    Validity() {
      if (this.isEmpty(this.CRType)) {
        this.$message({
          type: "error",
          message: "Please choose CR Type",
        });
        return;
      }

      var arr = this.approvalData.map((a) => a.approvalRules);
      var disarr = [...new Set(arr)];
      if (arr.length != disarr.length) {
        this.$message({
          type: "error",
          message: "Approval Rules不能重复",
        });
        return;
      }
    },
    bindCategory() {
      this.$api
        .get("/CR/GetProjectCategoryList/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            // if (res.data.content.length > 0) {
            //   res.data.content.forEach((item) => {
            //     item["isEdit"] = false;
            //   });
            // }
            this.projectData = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    bindInternalOrder() {
      this.$api
        .get("/CR/GetInternalOrderList/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {            
            this.internalOrderData = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    bindApprovalRules() {
      this.$api
        .get("/CR/GetApprovalRulesList/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            res.data.content.forEach((element) => {
              element.amountStart = element.amountStart.toFixed(2);
              element.amountEnd = element.amountEnd.toFixed(2);
            });
            this.approvalData = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    bindApprovalHierarchy() {
      this.$api
        .get("/CR/GetApprovalHierarchyList/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.hierarchyData = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    editRowEvent(row) {
      row.originalPrefix = row.prefix;
      row.originalSuffix = row.suffix;
      row.originalstatement_of_business_needs = row.statement_of_business_needs;
      row.isEdit = true;
    },
    saveRowEvent() {
      this.$confirm("此操作将修改数据,是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .post(
              "/CR/SaveProjectCategory",
               this.projectData,
              (res) => {}
            )
            .then((res) => {
              if (res.data.status) {
                this.$message({
                  type: "success",
                  message: res.data.content,
                });
                this.bindCategory();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
                return false;
              }
            });
        })
        .catch(() => {});
    },
    async cancelRowEvent(row) {
      row.prefix = row.originalPrefix;
      row.suffix = row.originalSuffix;
      row.statement_of_business_needs = row.originalstatement_of_business_needs;
      row.isEdit = false;
    },
    onClose() {
      this.bindCategory();
      this.bindInternalOrder();
    },
    saveInternalOrderRowEvent() {
      this.$confirm("此操作将修改数据,是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .post(
              "/CR/SaveInternalOrder",
               this.internalOrderData,
              (res) => {}
            )
            .then((res) => {
              if (res.data.status) {
                this.$message({
                  type: "success",
                  message: res.data.content,
                });
                this.bindCategory();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
                return false;
              }
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.bind();
    this.bindApprovalHierarchy();
    this.bindCategory();
  },
};
</script>
<style lang="scss">
#smart-cr-data {
  .el-table th {
    padding-left: 10px !important;
    padding-right: 10px !important;
    .cell {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
  .el-table td {
    padding: 5px 0 !important;
    .cell {
      height: 28px;
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.smart-cr-data {
  padding-bottom: 20px;
}

.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}

.content_title {
  margin: auto;
  width: 90%;
  text-align: center;
  margin-top: 10px;
  .d-list {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    font-weight: 500;
    margin-top: 20px;
    border: 1px solid #979797;
    .title {
      height: 49px;
      width: 100%;
      line-height: 50px;
      padding-left: 53px;
      text-align: left;
      background: #467c86;
      color: #fff;
      cursor: pointer;
    }
    .table {
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      .reason {
        text-align: left;
        margin-bottom: 10px;
        line-height: 32px;
      }
      .columns {
        height: 54px;
        display: flex;
        align-content: center;
        background: #97b6b9;
        color: #fff;
        .column {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          margin-right: 5px;
          margin-left: 5px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
      .tbody {
        display: flex;
        border-left: 1px solid #ddd;
        flex-wrap: wrap;
        .item {
          display: flex;
          width: 100%;
          align-content: center;
          justify-content: center;
        }
        .t-input {
          height: 54px;
          display: flex;
          align-items: center;
          flex: 1;
          overflow: hidden;
          padding-right: 5px;
          padding-left: 5px;
          border-right: 1px solid #ddd;
          border-bottom: 1px solid #ddd;
          box-sizing: border-box;
          .val-input {
            flex: 1;
            align-items: center;
          }
          .addcolumn {
            cursor: pointer;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }

      .content {
        width: 100%;
        height: 100%;
        border: 1px solid #979797;
        display: flex;
        flex-direction: column;
        .row {
          height: 53px;
          &.row-textarea {
            height: 86px;
          }
          line-height: 53px;
          display: flex;
          border-bottom: 1px solid #979797;
          &:last-child {
            border: 0;
          }
        }
      }
    }
    .txt {
      height: 100%;
      text-align: center;
      color: rgb(95, 95, 95);
      width: 158px;
      background: #fee7c5;
      border-right: 1px solid #979797;
      text-align: left;
      padding-left: 10px;
      line-height: normal;
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    .val {
      flex: 1;
      display: flex;
      align-items: center;
      line-height: normal;
      font-size: 14px;
      padding: 0 10px;
      font-weight: 500;
      border-right: 1px solid #979797;
      text-align: left;
      overflow: hidden;
      &.val-s {
        max-width: 360px;
      }

      .val-input {
        flex: 1;
      }
    }
    p {
      flex: 1;
      display: flex;
      overflow: hidden;
      &.d-flex-2 {
        flex: 2;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .button-search {
      background-color: #e6a23c;
      border: 0px #e6a23c;
      color: #ffff;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.tabledetail ::v-deep.numrule input::-webkit-outer-spin-button,
::v-deep.numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep.numrule input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/SmartCRData.vue